import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import { visaApplicationsAPI, agenciesAPI } from '../services/api';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState({
    pending: 0,
    approvedAgencies: 0,
    revenue: 0,
    attention: 0
  });

  useEffect(() => {
    async function fetchStats() {
      try {
        const [appRes, agencyRes] = await Promise.all([
          visaApplicationsAPI.getStats(),
          agenciesAPI.getStats()
        ]);

        const app = appRes.data?.data?.stats || {};
        const agency = agencyRes.data?.data?.stats || {};

        setStats({
          pending: (app.submitted || 0) + (app.in_review || 0) + (app.processing || 0),
          approvedAgencies: agency.approved || 0,
          revenue: app.total || 0,
          attention: (app.documents_required || 0) + (app.rejected || 0)
        });
      } catch (err) {
        console.error('Dashboard stats fetch failed:', err);
      }
    }
    fetchStats();
  }, []);

  const statsCards = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      ),
      label: 'PENDING PROCESSING',
      value: String(stats.pending),
      color: 'primary'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
      ),
      label: 'APPROVED AGENCIES',
      value: String(stats.approvedAgencies),
      color: 'success'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="1" x2="12" y2="23"></line>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
        </svg>
      ),
      label: 'TOTAL APPLICATIONS',
      value: String(stats.revenue),
      color: 'warning'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      ),
      label: 'ATTENTION NEEDED',
      value: String(stats.attention),
      color: 'error'
    }
  ];

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <main className="dashboard-main">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="page-title">ADMIN COMMAND CENTER</h1>
            <p className="page-subtitle">GLOBAL NETWORK NODE #0001</p>
          </div>
        </div>

        <div className="dashboard-content">
          <div className="stats-grid">
            {statsCards.map((card, index) => (
              <div key={index} className={`stat-card stat-${card.color}`}>
                <div className="stat-icon">{card.icon}</div>
                <div className="stat-info">
                  <span className="stat-label">{card.label}</span>
                  <span className="stat-value">{card.value}</span>
                </div>
                <div className="stat-indicator">
                  <span className="indicator-bar"></span>
                  <span className="indicator-text">REAL-TIME METRICS</span>
                </div>
              </div>
            ))}
          </div>

          <div className="dashboard-section">
            <div className="section-header">
              <h2 className="section-title">RECENT ACTIVITY</h2>
            </div>
            <div className="empty-state">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                <polyline points="13 2 13 9 20 9"></polyline>
              </svg>
              <p>No recent activity</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
